module.exports = __webpack_public_path__ + "media/img/pages/profile/aldi ger 4-cb588fd24d99bbc19410d4a5733cf298.jpg";